export default class ApplicationHelpController {
    /** @ngInject */
    constructor(TranslationService, $state) {
        this.TranslationService = TranslationService;
        this.$state = $state;
    }

    $onInit() {
        this.inProgress = false;
        this.updateMessage();
    }

    updateMessage() {
        const stateKey = this.$state.current.name.split('.').join('_');
        this.messageKey = `help_menu_${stateKey}`;
        this.helpMessage = this.TranslationService.getLine(this.messageKey);
    }
}



// WEBPACK FOOTER //
// ./app/common/help-menu/application-help/application-help.controller.js